<div class="tw-pb-6 tw-pl-6">
  @if (product === Product.PasswordManager) {
    <p class="tw-text-xl">
      {{ "trialThankYou" | i18n: orgLabel }}
    </p>
    @if (includesPrivilegedControls && trialLength > 0) {
      <p>
        {{ "trialIncludesPrivilegedControls" | i18n }}
      </p>
    }
  }
  @if (product === Product.SecretsManager) {
    <p class="tw-text-xl">
      {{ "smFreeTrialThankYou" | i18n }}
    </p>
  }
  <ul class="tw-list-disc">
    <li>
      <p>
        {{ "trialConfirmationEmail" | i18n }}
        <span class="tw-font-medium">{{ email }}</span
        >.
      </p>
    </li>
    @if (trialLength > 0) {
      <li>
        <p>
          {{ "trialPaidInfoMessageSpecificTrialLength" | i18n: orgLabel : trialLength }}
        </p>
      </li>
    }
  </ul>
</div>
